'use strict';

var g=o=>{console.log("logger: "+o);};

exports.a = g;
